require('./brokerContributionInvestmentFundsView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ actions
const contributionFundsActions = require('actions/contributionFunds');
const {
  sendBrokerPreContractualMailV2,
  resetPrecontractualMail,
} = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');
const PrinterActions = require('actions/contactCenter/printer');
const brokerLegalDocumentationActions = require('actions/brokerLegalDocumentation');
import { removeLegalDocumentation } from 'actions/brokerLegalDocumentation';
const BlockedAccountsAction = require('actions/blockedAccounts');
const brokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');

// @ commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ components
const BrokerContributionInvestmentFundHeader = require('components/broker/brokerContributionInvestment/brokerContributionInvestmentFundHeader/brokerContributionInvestmentFundHeader');
const BrokerContributionInvestmentFund = require('components/broker/brokerContributionInvestment/brokerContributionInvestmentFund/brokerContributionInvestmentFund');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @ helpers
const { buildLinks } = require('utilities/fundsHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { PROC_BROKER_FUNDS_PG_NAME } = require('utilities/tagging.js');

// @constants
const {
  FIRST_STEP,
  BROKER_RED_FUND,
  BROKER_YELLOW_FUND,
  BROKER_GREEN_FUND,
  BROKER_MIFID_FUND_RED,
  BROKER_MIFID_FUND_YELLOW,
  BROKER_MIFID_FUND_GREEN,
  BROKER_FUND_MIFID_ID,
  MYPROFILE_BROKER_EXPLORE_URL,
  MYPROFILE_BROKER_URL,
  MYPROFILE_BROKER_EXPLORE_FUNDS_URL,
  BROKER_DOCUMENT_TYPE,
  BROKER_ORDER_TYPE_BUY,
  BROKER_CONVENIENCE_MIFID_FUND,
  BROKER_CONVENIENCE_MIFID_FUND_BUY,
  BROKER_CONVENIENCE_MIFID_FUND_SUSCRIBE,
  BROKER_MIFID_VERSION_2,
} = require('constants/index');
const NextButtonWrapper = require('components/contactCenter/nextButtonWrapper/nextButtonWrapper');
const {
  FundLegalConfirmation,
} = require('components/contactCenter/brokerLegalConfirmation/fundLegalConfirmation/fundLegalConfirmation');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const {
  PRODUCT_TYPE,
  BUY_ORDER_TYPE,
} = require('constants/contactCenter/brokerFundsSendEmailConstants');
const { HIRE_FUNDS } = require('constants/operationCodesAccounts');

class BrokerContributionInvestmentFundsView extends React.Component {
  constructor(props) {
    super(props);

    this.checkMifid = true;

    this.state = {
      displayWizard: !__CONTACT_CENTER__,
      selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
      stepNumber: '',
    };

    this.handleFinish = this.handleFinish.bind(this);
    this.handleShowWizard = this.handleShowWizard.bind(this);
    this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
    this.onStepChange = this.onStepChange.bind(this);
  }

  componentDidMount() {
    const {
      onStartOperation,
      match: {
        params: { fundId, contractId },
      },
      getBlockedAccounts,
      immAccounts,
    } = this.props;
    onStartOperation(fundId, contractId);
    getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_FUNDS);
  }

  componentWillUnmount() {
    const { clearSearchResults, reset, resetPrintedIndicators, removeLegalDocumentation } =
      this.props;
    reset();
    resetPrintedIndicators();
    removeLegalDocumentation();
    clearSearchResults();
  }

  onStepChange(stepNumber) {
    this.setState({ stepNumber });
  }

  handleLegalYesNoOptionChange(value) {
    this.setState({
      selectedLegalConfirmationValue: value,
    });
  }

  handleShowWizard() {
    this.setState({
      displayWizard: true,
    });
  }

  getFundMifidId() {
    const fundType = this.props.immContributionFunds.getIn([
      'steps',
      FIRST_STEP,
      'contributionFunds',
      'customCategoryId3',
    ]);

    switch (fundType) {
      case BROKER_RED_FUND:
        return BROKER_MIFID_FUND_RED;
      case BROKER_YELLOW_FUND:
        return BROKER_MIFID_FUND_YELLOW;
      case BROKER_GREEN_FUND:
        return BROKER_MIFID_FUND_GREEN;
      default:
        return BROKER_FUND_MIFID_ID;
    }
  }

  buildHeader() {
    const mappingBreadcrumb = [
      {
        text: formatText('breadcrumb-brokerInvestments'),
        url: MYPROFILE_BROKER_URL,
      },
      {
        text: formatText(`breadcrumb-contirbutionFunds`),
        url: MYPROFILE_BROKER_URL,
      },
    ];

    return (
      <OKCover size="medium" section="broker" customClass="col-xs-12">
        <OKHeaderSubPage
          breadcrumbConfig={mappingBreadcrumb}
          finalTitle={getFinalTitle(formatText(`breadcrumb-contirbutionFunds`))}
        >
          <OKButton
            onClick={() => {
              taggingEventHandled(
                PROC_BROKER_FUNDS_PG_NAME,
                'GoToSearchButton',
                this.state.stepNumber
              );
            }}
            inverse={true}
            modifier="ghost"
            to={MYPROFILE_BROKER_EXPLORE_FUNDS_URL}
          >
            <FormattedText value="broker-goToAdvancedSearch" />
          </OKButton>
        </OKHeaderSubPage>
      </OKCover>
    );
  }

  handleCancel() {
    const url = MYPROFILE_BROKER_URL;
    this.props.history.push(url);
  }

  handleFinish() {
    const { history } = this.props;
    this.props.addSubscription(history);
  }

  isAbleToContinue() {
    return this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES;
  }

  buildNextButtonWrapperLegalConfirmation() {
    const {
      immProfileFields,
      immPreContractualMail,
      immContributionFunds,
      resetPrecontractualMail,
      requestProfile,
      sendBrokerPreContractualMailV2,
      immFlagBasedFeatures,
      match: {
        params: { fundId },
      },
    } = this.props;

    const fundIsin = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin']);
    const fundSecId = immContributionFunds.getIn([
      'steps',
      FIRST_STEP,
      'contributionFunds',
      'secId',
    ]);
    const fundName = trim(
      immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'name'])
    );
    const clientEmailAddress = PersonalDataHelper.getEmail(immProfileFields);
    const nombreCliente = immProfileFields.get('nombreCliente', '');

    const sendMailParams = {
      clientAlias: nombreCliente,
      email: clientEmailAddress,
      isin: fundIsin,
      isinDescribe: fundName,
      productType: PRODUCT_TYPE,
      orderType: BUY_ORDER_TYPE,
    };

    return (
      <NextButtonWrapper
        buttonContainerClassName="hire-investment-funds__next-button"
        canContinue={this.isAbleToContinue()}
        onContinue={this.handleShowWizard}
      >
        <FundLegalConfirmation
          className="content-box"
          fundIsin={fundIsin}
          fundSecId={fundSecId}
          fundName={fundName}
          immProfileFields={immProfileFields}
          immPreContractualMail={immPreContractualMail}
          sendMail={sendBrokerPreContractualMailV2}
          sendMailParams={sendMailParams}
          resetMailState={resetPrecontractualMail}
          requestProfile={requestProfile}
          selectedYesNoOption={this.state.selectedLegalConfirmationValue}
          onYesNoOptionChange={this.handleLegalYesNoOptionChange}
          costDocumentType={BROKER_DOCUMENT_TYPE}
          costOrderType={BROKER_ORDER_TYPE_BUY}
          fundId={fundId}
          withoutCostDocument={true}
        />
      </NextButtonWrapper>
    );
  }

  buildContributionView() {
    const {
      immContributionFunds,
      immAccounts,
      setVisibleStep,
      setAmount,
      setPeriodicity,
      setValidityDate,
      setDatePickerError,
      validateStep,
      setWillCancel,
      immBrokerProductAdvancedSearch,
      immFlagBasedFeatures,
      handleChangeReadChecked,
      resetFetchedPre,
      validateEconomicReport,
      removeLegalDocumentation,
      extantDataFetch,
    } = this.props;
    const header = this.buildHeader();
    const accountsMap = immAccounts.get('byId');
    const wizzardTitle = formatText('brokerContributionFundView-wizzardTitle');

    const isin = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin']);
    const customMinimumPurchaseAmount = immContributionFunds.getIn([
      'steps',
      0,
      'contributionFunds',
      'customMinimumPurchaseAmount',
    ]);
    const amount = immContributionFunds.getIn(['steps', FIRST_STEP, 'amount']);
    const amountErrorState = immContributionFunds.getIn(['steps', FIRST_STEP, 'amountErrorState']);
    const amountErrorMsg = immContributionFunds.getIn(['steps', FIRST_STEP, 'amountErrorMsg']);

    const periodicityError = immContributionFunds.getIn(['steps', FIRST_STEP, 'periodicityError']);
    const periodicityErrorMsg = immContributionFunds.getIn([
      'steps',
      FIRST_STEP,
      'periodicityErrorMsg',
    ]);
    const periodicityValue = immContributionFunds.getIn(['steps', FIRST_STEP, 'periodicityValue']);
    const periodicityOptions = immContributionFunds.getIn([
      'steps',
      FIRST_STEP,
      'periodicityOptions',
    ]);
    const hasPreviousContributions = immContributionFunds.getIn(['steps', FIRST_STEP, 'hasPreviousContributions']);
    const selectedDate = immContributionFunds.getIn(['steps', FIRST_STEP, 'selectedDate']);
    const minDate = immContributionFunds.getIn(['steps', FIRST_STEP, 'minDate']);
    const isValidDate = immContributionFunds.getIn(['steps', FIRST_STEP, 'isValidDate']);
    const legalConfirmation =
      __CONTACT_CENTER__ && !this.state.displayWizard
        ? this.buildNextButtonWrapperLegalConfirmation()
        : null;

    return (
      <div>
        <div className="container-fluid card-details--header-identifier">
          <div className="row">{header}</div>
        </div>
        <div className="grid-view__body">
          <div className="container-fluid">
            <div className="row grid-view--content-position-negative">
              <div className="col-xs-12">
                <BrokerContributionInvestmentFundHeader
                  immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                  immContributionFunds={immContributionFunds}
                  modifier="etfs"
                />
                {legalConfirmation}
                {this.state.displayWizard && (
                  <BrokerContributionInvestmentFund
                    immContributionFunds={immContributionFunds}
                    immAccounts={accountsMap}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    /* step1 */
                    isin={isin}
                    onStepChange={this.onStepChange}
                    customMinimumPurchaseAmount={customMinimumPurchaseAmount}
                    amount={amount}
                    amountErrorState={amountErrorState}
                    amountErrorMsg={amountErrorMsg}
                    setAmount={setAmount}
                    periodicityError={periodicityError}
                    periodicityErrorMsg={periodicityErrorMsg}
                    periodicityValue={periodicityValue}
                    periodicityOptions={periodicityOptions}
                    setPeriodicity={setPeriodicity}
                    setValidityDate={setValidityDate}
                    selectedDate={selectedDate}
                    minDate={minDate}
                    datePickerDisabled={hasPreviousContributions}
                    setDatePickerError={setDatePickerError}
                    isValidDate={isValidDate}
                    handleChangeReadChecked={handleChangeReadChecked}
                    resetFetchedPre={resetFetchedPre}
                    validateEconomicReport={validateEconomicReport}
                    removeLegalDocumentation={removeLegalDocumentation}
                    extantDataFetch={extantDataFetch}
                    /* wizard */
                    setVisibleStep={setVisibleStep}
                    setWillCancel={setWillCancel}
                    validateStep={validateStep}
                    onCancel={() => this.handleCancel()}
                    onFinish={this.handleFinish}
                    wizzardTitle={wizzardTitle}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  buildContributionViewMifid() {
    const {
      immContributionFunds,
      match: {
        params: { fundId, contractId },
      },
    } = this.props;
    const fundType = this.props.immContributionFunds.getIn([
      'steps',
      FIRST_STEP,
      'contributionFunds',
      'customCategoryId3',
    ]);
    const productName = trim(
      immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'name'])
    );

    const productUrl = buildLinks(
      immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin'])
    );
    const appendContract = contractId ? `/${contractId}` : '';
    const continuationUrl = `/myprofile/broker/fundsPeriodicContribution/${fundId}${appendContract}`;
    const productType = contractId
      ? BROKER_CONVENIENCE_MIFID_FUND_SUSCRIBE
      : BROKER_CONVENIENCE_MIFID_FUND;
    const mifidOptions = {
      hideAlreadyPerformTestResult:
        fundType === BROKER_YELLOW_FUND || fundType === BROKER_GREEN_FUND,
      productType,
      operationType: BROKER_CONVENIENCE_MIFID_FUND_BUY,
    };

    return (
      <BrokerMiFIDBehavior
        mifidVersion={BROKER_MIFID_VERSION_2}
        productName={productName}
        productUrl={productUrl}
        continuationUrl={continuationUrl}
        productIsinId={immContributionFunds.getIn([
          'steps',
          FIRST_STEP,
          'contributionFunds',
          'isin',
        ])}
        productMifidId={this.getFundMifidId()}
        mifidOptions={mifidOptions}
      >
        {this.buildContributionView()}
      </BrokerMiFIDBehavior>
    );
  }

  render() {
    const { immContributionFunds, immBrokerProductAdvancedSearch,
      match: {
        params: { mifid },
      } } = this.props;
    
    const header = this.buildHeader();
    const notFound = immContributionFunds.get('notFound');
    const hasPreviousContributions = immContributionFunds.getIn(['steps', FIRST_STEP, 'hasPreviousContributions']);
    if (
      immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds']) &&
      immBrokerProductAdvancedSearch.get('fetched')
    ) {
      if (hasPreviousContributions || mifid === 'skip' ) {
        return this.buildContributionView();
      } else {
        return this.buildContributionViewMifid();
      }
    } else if (notFound) {
      return (
        <div>
          <div className="container-fluid">
            <div className="row">{header}</div>
          </div>
          <div className="grid-view__body">
            <div className="container-fluid">
              <div className="row grid-view--content-position-positive">
                <div className="col-xs-12">
                  <EmptyState
                    primaryText={'No se han encontrado datos del fondo'}
                    iconType="noitems-banking"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <LoadingSection />;
    }
  }
}

BrokerContributionInvestmentFundsView.propTypes = {
  immContributionFunds: PropTypes.object,
  onStartOperation: PropTypes.func.isRequired,
  resetPrintedIndicators: PropTypes.func.isRequired,
  addSubscription: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  reset: PropTypes.func.isRequired,
  /* wizard */
  setVisibleStep: PropTypes.func.isRequired,
  setWillCancel: PropTypes.func.isRequired,
  validateStep: PropTypes.func.isRequired,
  immAccounts: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,

  isin: PropTypes.string.isRequired,
  onStepChange: PropTypes.func,
  setAmount: PropTypes.func,
  setPeriodicity: PropTypes.func.isRequired,
  setValidityDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.object,

  immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
  immProfileFields: PropTypes.object.isRequired,
  immPreContractualMail: PropTypes.object.isRequired,
  immReimburseInvestment: PropTypes.object.isRequired,
  sendBrokerPreContractualMailV2: PropTypes.func.isRequired,
  resetPrecontractualMail: PropTypes.func.isRequired,
  getBlockedAccounts: PropTypes.func.isRequired,
  requestProfile: PropTypes.func.isRequired,
  removeLegalDocumentation: PropTypes.func.isRequired,
  clearSearchResults: PropTypes.func.isRequired,
  immFlagBasedFeatures: PropTypes.object,
};

module.exports.constructor = BrokerContributionInvestmentFundsView;
module.exports.BrokerContributionInvestmentFundsView = connect(
  state => ({
    immContributionFunds: state.contributionFunds,
    immAccounts: state.accounts,
    immProfileFields: state.profile,
    immPreContractualMail: state.preContractualMail,
    immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
    immBrokerFundLegalDocument: state.brokerFundLegalDocument,
    immBrokerMyInvestments: state.brokerMyInvestments,
    immReimburseInvestment: state.reimburseInvestment,
    immStocksContractForm: state.brokerStocksContractForm,
    immFlagBasedFeatures: state.flagBasedFeatures,
  }),
  {
    onStartOperation: contributionFundsActions.operationStarted,
    addSubscription: contributionFundsActions.addSubscription,
    setAmount: contributionFundsActions.setAmount,
    setPeriodicity: contributionFundsActions.setPeriodicity,
    setValidityDate: contributionFundsActions.setValidityDate,
    resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
    getBlockedAccounts: BlockedAccountsAction.getBlockedAccounts,
    resetBlockedAccounts: BlockedAccountsAction.resetBlockedAccounts,
    validateStep: contributionFundsActions.validateStep,
    setVisibleStep: contributionFundsActions.setVisibleStep,
    setWillCancel: contributionFundsActions.setWillCancel,
    setDatePickerError: contributionFundsActions.setDatePickerError,
    reset: contributionFundsActions.reset,
    getMorningStarScreener: contributionFundsActions.getMorningStarScreener,
    sendBrokerPreContractualMailV2: sendBrokerPreContractualMailV2,
    resetPrecontractualMail: resetPrecontractualMail,
    requestProfile: profileActions.requestProfile,
    removeLegalDocumentation: removeLegalDocumentation,
    clearSearchResults: brokerProductAdvancedSearchActions.clearResults,

    handleChangeReadChecked: contributionFundsActions.changeReadChecked,
    resetFetchedPre: contributionFundsActions.resetFetchedPre,
    validateEconomicReport: contributionFundsActions.validateEconomicReport,
    removeLegalDocumentation: brokerLegalDocumentationActions.removeLegalDocumentation,
    extantDataFetch: contributionFundsActions.postExtantCostsBuyFunds,
  }
)(withRouter(BrokerContributionInvestmentFundsView));
